import api from '@/api';

const resource = 'ei/professor';

export default {
  getListaProfessorPorEscola(data) {
    return api.get(`${resource}/select-professor-escola`, {
      params: data,
    });
  },

  getListaProfessorPorTurmaDisciplina(data) {
    return api.get(`${resource}/select-professor-por-turma-disciplina`, {
      params: data,
    });
  },
};
